import Vue from 'vue'
import store from '@/store'

/**
 * Action คำสั่งอนุญาต(ใช้เพื่อควบคุมปุ่มการกระทำบนเพจ)
 * การใช้คำสั่ง：
 *  - จำเป็นต้องได้รับการควบคุม action ใช้กับส่วนประกอบที่มีสิทธิ์ระดับ v-action="'value'" , ดังต่อไปนี้：
 *    <el-button v-action="'add'" >เพิ่มผู้ใช้</el-button>
 *    <el-button v-action="'delete'">ลบผู้ใช้</el-button>
 * 
 *  - ถ้าเป็นกลุ่มปุ่มละก็v-action.group="['value', 'value']" ,ใช้แทนปุ่มทั้งหมดด้วย'-'
 *  - กลุ่มปุ่มต้องมีสิทธิ์ของปุ่มย่อยทั้งหมด
 */
Vue.directive('action', {
	inserted: function (el, binding, vnode) {
		const { modifiers, value } = binding
		const permissionKey = vnode.context?.$route.meta?.permission
		const parentNode = el.parentNode
		const { root, auth } = store.getters.permission
		if (root) {
            // ในฐานะผู้ดูแลระบบ
            return true
        }
        if (!permissionKey) {
            // เลขที่permissionKeyจากนั้นเพจไม่จำเป็นต้องมีการควบคุมการอนุญาต
            return 
        }
		const [key] = permissionKey.split(".")
		const actions = auth[key]
		if(!actions) {
			return
		}
	
		if(!modifiers.group) {
			// กลุ่มที่ไม่ใช่ปุ่ม
			if (actions && !actions.includes(value)) {
				parentNode?.removeChild(el) || (el.remove())
			}
			return
		}
		console.log(value)
		if(Array.isArray(value) && !value.some((item: string) => actions.includes(item))) {
			// กลุ่มปุ่ม
			const span = document.createElement('span')
			span.innerHTML = '-'
			parentNode?.insertBefore(span, el)
			parentNode?.removeChild(el) || (el.remove())
		}

	}
})



